<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.operator_information") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-lg-3.col-xl-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fas.fa-globe-africa
                  DebounceInput(type="text" v-model="siteName" :placeholder="$t('ui.site_name')" @enter="getSiteLoginList(true)" size="sm")

              .form-group.col-xl-2.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getSiteLoginList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="10%")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th(width="10%")
                          span(:title="$t('ui.site_name')") {{ $t('ui.site_name') }}
                        th(width="10%")
                          span(:title="$t('ui.bo_link')") {{ $t('ui.bo_link') }}
                    tbody.clusterize-content
                      tr(v-if="siteLoginList.length == 0")
                        td(colspan="5").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in siteLoginList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.operator_id") {{ item.operator_id }}
                        td
                          span(:title="item.site_name") {{ item.site_name }}
                        td
                          a(:href="'http://' + item.bo_url" target="_blank") {{ item.bo_url }}


</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    siteName: '',
    siteLoginList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
    this.getSiteLoginList(true);
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSiteLoginList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSiteLoginList();
    },
    getSiteLoginList: function(isSearch) {
      if (isSearch) this.currentPage = 1;
      let url = config.siteLoginAccessListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        currency: this.getCurrencyCode,
        site_name: this.siteName,
        // site_status: null
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                var list = response.data.dt
                this.siteLoginList = [];
                this.siteLoginList = list;
                this.totalRow = this.siteLoginList.length > 0 ? this.siteLoginList[0].totalrows : 0;

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            // console.log(error)
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>